import React from 'react';

function Content({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <rect x="4" y="4" width="9" height="9" rx="1.3" />
      <rect x="4" y="17.3333" width="9" height="9" rx="1.3" />
      <path d="M18.667 6H28.0003M18.667 9.33333H28.0003M18.667 12.6667H24.0003" />
      <path d="M18.667 19.3333H28.0003M18.667 22.6667H28.0003M18.667 26H24.0003" />
    </svg>
  );
}

export default Content;
